import { render, staticRenderFns } from "./BrandHero.vue?vue&type=template&id=c8cf3f94&lang=pug&"
import script from "./BrandHero.vue?vue&type=script&lang=js&"
export * from "./BrandHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports